// ManageCustomers.jsx
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import api from '../../api'
import { RiSearchLine, RiLoader4Line, RiUserLine } from 'react-icons/ri'

export default function ManageCustomers() {
  const [search, setSearch] = useState('')
  const [page,   setPage]   = useState(1)

  const { data, isLoading } = useQuery({
    queryKey: ['admin-customers', search, page],
    queryFn: () => api.get('/admin/customers', { params: { search, page } }),
    select: (r) => r.data,
  })

  const customers = data?.data || []
  const meta      = data?.meta || {}

  return (
    <div className="space-y-5">
      <h2 className="font-display text-salon-dark text-2xl font-bold">Customers</h2>

      <div className="relative max-w-sm">
        <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 text-salon-muted" />
        <input value={search} onChange={(e) => { setSearch(e.target.value); setPage(1) }}
          className="input-field pl-9 text-sm" placeholder="Search customers..." />
      </div>

      <div className="bg-white rounded-2xl border border-salon-cream-dark overflow-hidden">
        {isLoading ? (
          <div className="flex justify-center py-20"><RiLoader4Line className="animate-spin text-3xl text-salon-primary" /></div>
        ) : (
          <table className="w-full text-sm font-body">
            <thead>
              <tr className="bg-salon-cream text-salon-muted text-xs font-semibold uppercase tracking-wider">
                <th className="text-left px-5 py-3">Customer</th>
                <th className="text-left px-5 py-3">Email</th>
                <th className="text-left px-5 py-3">Phone</th>
                <th className="text-left px-5 py-3">Total Bookings</th>
                <th className="text-left px-5 py-3">Total Spent</th>
                <th className="text-left px-5 py-3">Joined</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-salon-cream-dark">
              {customers.length === 0 ? (
                <tr><td colSpan={6} className="text-center py-16 text-salon-muted">No customers found</td></tr>
              ) : customers.map((c) => (
                <tr key={c.id} className="hover:bg-salon-cream/30 transition-colors">
                  <td className="px-5 py-3.5">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-salon-primary/10 flex items-center justify-center text-salon-primary font-bold text-sm">
                        {c.name.charAt(0)}
                      </div>
                      <p className="font-medium text-salon-dark">{c.name}</p>
                    </div>
                  </td>
                  <td className="px-5 py-3.5 text-salon-muted">{c.email}</td>
                  <td className="px-5 py-3.5 text-salon-muted">{c.phone}</td>
                  <td className="px-5 py-3.5 text-salon-dark">{c.appointments_count || 0}</td>
                  <td className="px-5 py-3.5 text-salon-secondary font-semibold">₹{(c.total_spent || 0).toLocaleString()}</td>
                  <td className="px-5 py-3.5 text-salon-muted">{c.created_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
